import { render, staticRenderFns } from "./Transporter.vue?vue&type=template&id=9fa3185a"
import script from "./Transporter.vue?vue&type=script&lang=js"
export * from "./Transporter.vue?vue&type=script&lang=js"
import style0 from "./Transporter.vue?vue&type=style&index=0&id=9fa3185a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports